'use strict';
const Offset = require('./offset');
module.exports = function NodeTreeSet() {
	const self = this,
		positioned = [],
		unpositioned = [],
		highestPriorityNodeTree = () => {
			return positioned.sort((nodeTree1, nodeTree2) => {
				return nodeTree2.priority - nodeTree1.priority;
			})[0];
		};

	self.append = (nodeTree) => {
		if (nodeTree.priority) {
			positioned.push(nodeTree);
		} else {
			unpositioned.push(nodeTree);
		}

	};
	self.nodeTreesInPlacementOrder = (contextNodeId) => {
		const contextNodeTree = contextNodeId && positioned.find(nodeTree => nodeTree.contains(contextNodeId)),
			firstToPlace = contextNodeTree || highestPriorityNodeTree(),
			origin =  contextNodeTree ? contextNodeTree.nodeForId(contextNodeId) : {x: 0, y: 0},
			result = positioned.sort((nodeTree1, nodeTree2) => {
				if (nodeTree1 === firstToPlace) {
					return -1;
				}
				if (nodeTree2 === firstToPlace) {
					return 1;
				}
				const ext1 = nodeTree1.extensionFrom(origin),
					ext2 = nodeTree2.extensionFrom(origin);
				return ext1 - ext2;
			}).concat(unpositioned);
		return result;
	};
	self.count = () => positioned.length + unpositioned.length;

	self.allNodesOffset = () => {
		const result = {};
		positioned.concat(unpositioned).forEach(nodeTree => Object.assign(result, nodeTree.nodeDictionaryOffset()));
		return result;
	};
	self.getMovementOrigin = (contextNodeId) => {
		const contextNodeTree = contextNodeId && positioned.find(nodeTree => nodeTree.contains(contextNodeId)),
			contextNode = contextNodeTree && contextNodeTree.nodeForId(contextNodeId),
			origin = contextNode && contextNodeTree.getCurrentOffset().add(contextNode);
		return origin || new Offset({x: 0, y: 0});
	};
};
